module.exports = __webpack_public_path__ + "img/lock.53eb54da.svg";